import React, { useState } from 'react';
import WithConsumer from '../../context/WithConsumer';
import { Link } from 'react-router-dom';
import GravityForm from "react-gravity-form";

const Footer = ({ context }) => {
	
	const ctxGlobal 		= () => context.global;
	const global 			= ctxGlobal();
	
	const ctxPageLoaded 	= () => context.pageLoaded;
    const pageLoaded 		= ctxPageLoaded();
    
	const ctxBgColor 		= () => context.bgColor;
    const bgColor 			= ctxBgColor();
    
    const posts 			= () => context.posts;
    const post 				= posts()[0];
			
    if (global && post) {
							
		if (global.json === null) {
			context.getGlobal(window.location.origin + '/wp-json/mim-design/v1/global');
		}
	  		  	
	  	if (global.json !== null && post.footer !== false) {  
		  	
		  	let footerClass = 'c-footer';
	    	
	    	
	    	if (pageLoaded) {
		    	footerClass = footerClass + ' state-page-loaded'
	    	}
	    	
			if (bgColor === 'black') {
				footerClass = footerClass + ' scope-black-bg';
	    	}
			return (
				<>
			    	<div className={footerClass}>
						<div className="c-footer__inner">
							{global.json.subscribe_form_menu &&
								<div className="scope-subscription-form">
				    				<GravityForm
										backendUrl={document.location.origin + '/wp-json/mim-design/v1/form'}
										formID={global.json.subscribe_form_menu}
									/>
								</div>
							}
							<div className="c-footer__links">
								{global.json.privacy_url &&
									<Link to={{ pathname: global.json.privacy_url }} className="c-menu__footer__privacy">Privacy Policy</Link>
								}
							</div>
						</div>
					</div>
				</>
			)
		
		} else {
			
			return null;
			
		}
		
	} else {
		
		return null;
		
	}
		
}
export default WithConsumer(Footer);